import { NavLink } from "react-router-dom";
import BrandLogo from "@/components/feature/BrandLogo";
import { ADMIN_NAV } from "@/components/feature/adminNav";
import { useAuth } from "@/context/AuthContext";
import { useAppSettings } from "@/context/AppSettingsContext";
import { BRAND_NAME } from "@/lib/constants";

export default function AdminSidebar() {
  const { profile, roleName } = useAuth();
  const { settings } = useAppSettings();

  const active = ADMIN_NAV.filter((item) => !item.phase);
  const upcoming = ADMIN_NAV.filter((item) => item.phase);

  return (
    <aside className="hidden lg:flex lg:w-[264px] lg:shrink-0 lg:flex-col border-r border-background-200 bg-background-100">
      <div className="flex h-16 items-center gap-3 border-b border-background-200 px-5">
        <BrandLogo size={38} />
        <div className="min-w-0">
          <p className="font-heading truncate text-sm font-bold text-foreground-950">
            {settings.company_name || BRAND_NAME}
          </p>
          <p className="truncate text-[11px] text-foreground-500">Panel administrativo</p>
        </div>
      </div>

      <nav className="rkc-scroll-thin flex-1 overflow-y-auto px-3 py-4">
        <p className="px-2 pb-2 text-[11px] font-semibold uppercase tracking-wider text-foreground-400">
          Operación
        </p>
        <ul className="flex flex-col gap-1">
          {active.map((item) => (
            <li key={item.key}>
              <NavLink
                to={item.path}
                end={item.path === "/admin"}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-200"
                  }`
                }
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <span className="truncate">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <p className="px-2 pb-2 pt-5 text-[11px] font-semibold uppercase tracking-wider text-foreground-400">
          Próximas fases
        </p>
        <ul className="flex flex-col gap-1">
          {upcoming.map((item) => (
            <li
              key={item.key}
              className="flex cursor-default items-center gap-3 rounded-md px-3 py-2.5 text-sm text-foreground-400"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <span className="min-w-0 flex-1 truncate">{item.label}</span>
              <span className="rounded-full bg-background-200 px-2 py-0.5 text-[10px] font-semibold text-foreground-500">
                Fase {item.phase}
              </span>
            </li>
          ))}
        </ul>
      </nav>

      <div className="border-t border-background-200 p-3">
        <div className="flex items-center gap-3 rounded-md bg-background-50 px-3 py-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
            {(profile?.full_name?.[0] ?? "A").toUpperCase()}
          </span>
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold text-foreground-900">
              {profile?.full_name} {profile?.last_name}
            </p>
            <p className="truncate text-[11px] text-foreground-500">
              {roleName === "admin" ? "Administrador" : "Cajero"}
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
}